import * as React from 'react'
// libs
import { WrappedFieldArrayProps } from 'redux-form'
// views
import { Title } from './view'
import { AddButton } from 'components/Modals/SystemProcessModal/Form/components/views'
// components
import Transaction from './components/Transaction'

const renderTransactions: React.FC<WrappedFieldArrayProps<any>> = ({ fields }) => {
  const addTransaction = () => fields.push({})

  const removeTransaction = (idx: number) => () => fields.remove(idx)

  return (
    <>
      <Title>Transactions</Title>
      {fields.map((field, idx) => (
        <Transaction key={field} field={field} index={idx} removeField={removeTransaction(idx)} />
      ))}
      <AddButton data-testid='system-process-add-transaction' onClick={addTransaction}>
        + add a transaction to this process
      </AddButton>
    </>
  )
}

export default renderTransactions
